// import screen2 from '../../../images/screen1-0';
import screen2 from '../../../images/mockups/16-portrait.png';
function FirstContentA() {
  return (
    <div className="flex flex-col items-center w-screen overflow-hidden">
      <div className="flex flex-row justify-between pb-60 m10:flex-col items-center max-w-7xl w-full px-10 m6:px-5" id="FirstContentA-wrapper">
        <div className="w-3/5 m10:w-full">
          <div className="text-6xl m10:text-center" id='first-compA-slogan'>
            La Carte
          </div>
          <div className="pt-5 text-2xl m10:text-center" id='first-compA-description'>
            Visualisez & planifiez en temps réel toutes vos maintenances sur l'entièreté de votre domaine skiable. Grâce à la visualisation graphique, vos interventions seront marquées et répertoriées sur des zones précises.          </div>
        </div>
        <div className="flex items-center justify-center m10:pt-20 " id='first-compA-right-side'>
          <img src={screen2} className="w-96" id='first-compA-screen' alt='screen2' />
        </div>
      </div>
    </div>
  );
}

export default FirstContentA;